import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RecentEventsResponse } from '@core/interfaces/event-log.interface';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface RecentEventsFilters {
  eventType?: string;
  flowToken?: string;
  line?: string;
  group?: string;
  campaignCode?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  public urlBackEnd: string = environment.base_url;

  constructor(private http: HttpClient) {}

  getRecentEvents(filters: RecentEventsFilters = {}): Observable<RecentEventsResponse> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });

    return this.http
      .get<RecentEventsResponse>(`${this.urlBackEnd}/events/recent`, { params })
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.error('HTTP Error:', error.status, error.error?.msg);
    return throwError(() => error);
  }
}
